"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

require("svgxuse/svgxuse");

var _core = require("@emotion/core");

function IconBase(_ref) {
  var className = _ref.className,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      name = _ref.name,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "focusable", "name"]);
  var theme = (0, _theme.useTheme)();
  var iconSprite = typeof theme.components.icon.url === 'function' ? theme.components.icon.url() : theme.components.icon.url;
  var prefix = theme.components.icon.prefix || '';
  return (0, _core.jsx)("span", {
    className: className
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    viewBox: "0 0 24 24",
    focusable: focusable
  }, props), (0, _core.jsx)("use", {
    xlinkHref: "".concat(iconSprite, "#").concat(prefix).concat(name)
  })));
}

var _default = _react.default.memo(IconBase);

exports.default = _default;